import React from "react";
import { Link } from "react-router-dom";
import { useStore } from "../context/StoreContext";
import { formatPrice } from "../lib/api";
import { Heart, X, ShoppingBag } from "lucide-react";

export default function Wishlist() {
  const { wishlist, toggleWishlist, addToCart } = useStore();

  if (wishlist.length === 0) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-24 text-center" data-testid="wishlist-empty">
        <Heart size={48} className="text-gold mx-auto mb-6" strokeWidth={1} />
        <h1 className="font-serif text-3xl text-navy">Списъкът с любими е празен</h1>
        <p className="text-charcoal/60 mt-3">Запазвайте картини, които харесвате, за по-късно.</p>
        <Link to="/kartini" className="btn-gold inline-block px-8 py-3 rounded-sm mt-8">Разгледай картините</Link>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12" data-testid="wishlist-page">
      <h1 className="font-serif text-3xl md:text-4xl text-navy mb-8">Любими картини</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
        {wishlist.map((i) => (
          <div key={i.id} className="bg-white border border-stone group" data-testid={`wishlist-item-${i.id}`}>
            <div className="relative aspect-[4/5] overflow-hidden">
              <Link to={`/kartina/${i.slug || i.id}`}><img src={i.image} alt={i.title} className="w-full h-full object-cover" /></Link>
              <button onClick={() => toggleWishlist(i)} className="absolute top-3 right-3 w-8 h-8 bg-white/90 rounded-full flex items-center justify-center text-navy" data-testid={`wishlist-remove-${i.id}`}><X size={15} /></button>
            </div>
            <div className="p-4">
              <h3 className="font-serif text-lg text-navy line-clamp-1">{i.title}</h3>
              <p className="font-serif text-gold mt-1">{formatPrice(i.price)}</p>
              <button onClick={() => addToCart(i)} className="btn-navy-outline w-full py-2 mt-3 rounded-sm text-sm flex items-center justify-center gap-2"><ShoppingBag size={14} /> Добави</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
